<template src="../templates/normal_fcont_171.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import PrintButton from '../components/PrintButton'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '171',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,PrintButton,AppDownloadCreative,AppDownloadPhotoPlusJp
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['171-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['171-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
ul.note171 {
  margin-top: 40px;
}

h4.prepare {
  margin-top: 30px;
  margin-bottom: 0px;
}

.prepare171 {
  margin-top: 30px;
}
</style>

